export default __webpack_public_path__ + "static/blob7-78a5d7c68eed37bc962c3802925e7add.svg";